var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radial-bar",style:({ '--percentage': _vm.hasFixedRadial ? '100%' : _vm.percentage + '%', '--radial-colour': _vm.colour })},[_c('div',{staticClass:"percentage-container"},[_c('div',{staticClass:"percentage"},[_vm._v(_vm._s(_vm.percentage)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }